const Behaviors = ( function () {
    'use strict'

    const init = function () {
        const btnMenuToggle = $('[data-behavior=toggle-menu]');
        if(btnMenuToggle !== null) {
            $(btnMenuToggle).on('click', function () {
                ToggleMenu.toggle(this);
            });
        }

        const btnFilterToggle = $('[data-behavior=toggle-filter]');
        if(btnFilterToggle !== null) {
            $(btnFilterToggle).on('click', function() {
                ToggleFilter.toggle(this);
            });
        }

        $('body').on('click', '[data-behavior=open-overlay]', function(e) {
            Overlay.open();
            e.preventDefault();
        });

        $('body').on('click', '[data-behavior=close-overlay]', function() {
            Overlay.close();
        });


        $('body').on('click', '[data-behavior=show-products]', function(e) {
            Products.open($(this));
            e.preventDefault();
        });

        $('body').on('click', '[data-behavior=hide-products]', function() {
            Products.close();
        });

        $('body').on('click', '[data-behavior=show-license]', function() {
            License.show($(this).attr('data-file-url'), $(this).attr('data-license-url'));
        });

        $('body').on('click', '[data-behavior=toggle-collapsible]', function() {
            Collapsibles.toggle(this);
        });

    }

    return {
        init: init,
    }
})();
